module.exports = __webpack_public_path__ + "static/media/egg.d64398d4.svg";